export default "__VITE_ASSET___kfr8MQ1__"